import {
    TransactionColumn,
    TransactionView,
} from "@common/types/views/transactionViews";
import { NamedView, ViewType } from "@common/types/views/views";
import { DEFAULT_VIEW_ID } from "@components/views/constants";

interface CreateDefaultTransactionViewOptions {
    entityIds: number[];
    hasAnyClass: boolean;
    isGlFirst: boolean;
    showOriginalBankDescription?: boolean;
}

export const createDefaultTransactionView = ({
    entityIds,
    hasAnyClass,
    isGlFirst,
    showOriginalBankDescription = false,
}: CreateDefaultTransactionViewOptions): NamedView<TransactionView> => ({
    id: DEFAULT_VIEW_ID,
    name: "All Transactions",
    type: ViewType.TRANSACTION,
    options: {
        bulkActions: true,
        selection: true,
    },
    columns: [
        {
            id: TransactionColumn.LOCK,
            options: {
                pin: "left",
            },
        },
        {
            id: TransactionColumn.DATE,
            options: {
                pin: "left",
            },
        },
        {
            id: TransactionColumn.SPLIT,
            options: {
                pin: "left",
            },
        },
        {
            id: showOriginalBankDescription
                ? TransactionColumn.BANK_DESCRIPTION
                : TransactionColumn.DESCRIPTION,
        },
        // GL-first workspaces classify by general ledger account, so the
        // Cash ledger column replaces Category and Counterparty replaces Class.
        ...(isGlFirst
            ? [
                  { id: TransactionColumn.COUNTERPARTY as const },
                  { id: TransactionColumn.LEDGER as const },
              ]
            : [
                  { id: TransactionColumn.CATEGORY as const },
                  ...(hasAnyClass
                      ? [{ id: TransactionColumn.CLASSES as const }]
                      : []),
              ]),
        {
            id: TransactionColumn.ACCOUNT,
        },
        {
            id: TransactionColumn.AMOUNT,
            options: {
                pin: "right",
            },
        },
        {
            id: TransactionColumn.ENTITY,
            options: {
                pin: "right",
            },
        },
    ],
    filters: {
        entityIds,
    },
});
